var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "500"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Evento do Calendário ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('sca-required-fields'), _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    staticClass: "mb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Evento do Calendário*",
      "outlined": "",
      "dense": "",
      "counter": "100",
      "maxlength": "100",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 100);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', {
    staticClass: "text-body-1 mr-2 grey--text text--darken-1"
  }, [_vm._v("Cor*")])]), _c('sca-color-picker', {
    attrs: {
      "cols": 2
    },
    model: {
      value: _vm.content.corHexadecimal,
      callback: function ($$v) {
        _vm.$set(_vm.content, "corHexadecimal", $$v);
      },
      expression: "content.corHexadecimal"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex align-center mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', {
    staticClass: "text-body-1 mr-2 grey--text text--darken-1"
  }, [_vm._v("Dia Letivo*")])]), _c('v-switch', {
    model: {
      value: _vm.content.diaLetivo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "diaLetivo", $$v);
      },
      expression: "content.diaLetivo"
    }
  })], 1)], 1)], 1), _c('sca-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Editar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }